const CABIN_CLASS = 'cabinClass';
const BOOKING_CLASS = 'bookingClass';

export { CABIN_CLASS, BOOKING_CLASS };
